module.exports = __webpack_public_path__ + "img/file3.2144d1cd.svg";